import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("text", {
  transform: "translate(9 12)",
  style: {"font-size":"9px","font-family":"RakutenSansUI-Bold,Rakuten Sans UI","font-weight":"700","letter-spacing":"-.1em"}
}, [
  /*#__PURE__*/_createElementVNode("tspan", {
    x: "-8.815",
    y: "0"
  }, "K8"),
  /*#__PURE__*/_createElementVNode("tspan", {
    y: "0",
    style: {"font-size":"10px"}
  }, "s")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };